import { render, staticRenderFns } from "./BReverseTech.vue?vue&type=template&id=72aef8dc&"
import script from "./BReverseTech.vue?vue&type=script&lang=ts&"
export * from "./BReverseTech.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports